import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfMotivos } from '../interfaces/tablas/IConfMotivos'
export class MotivosService extends BaseService<IConfMotivos> {
  constructor () {
    super({
      baseUrl: 'scheduling/reasons/'
    })
  }
}
